import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebhookTableComponent } from './webhook-table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';



@NgModule({
  declarations: [
    WebhookTableComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule.forRoot({
      theme: {
        // Enabliong theme combination
        extendsFromRoot: true,
        // ... list of CSS theme attributes
        height: '72px',
        width: '100%',
        margin: '10px 0px'
      },
    }),
  ],
  exports: [
    WebhookTableComponent
  ]
})
export class WebhookTableModule { }
